import React from "react";
import { ROUTES } from "../routes";
import acreage from "../assets/sidebaricons/acreageInactive.svg";
import acreageActive from "../assets/sidebaricons/acreageActive.svg";

// const AcreageIcon = (location) => {
//   return (
//     <img
//       alt=""
//       className={
//         location.location === ROUTES.ACREAGE
//           ? "sideBarIcon"
//           : "sideBarIcon-not-selected"
//       }
//       style={{ width: "35px", height: "35px" }}
//       src={location.location === ROUTES.ACREAGE ? acreageActive : acreage}
//     />
//   );
// };
const AcreageIcon = (location) => {
  const isActive = location.location === ROUTES.ACREAGE;
  return (
    <img
      alt=""
      className={isActive ? "sideBarIcon" : "sideBarIcon-not-selected"}
      style={{
        width: "21px",
        height: "21px",
        minWidth: "21px",
        minHeight: "21px",
      }}
      src={isActive ? acreageActive : acreage}
    />
  );
};

export default AcreageIcon;
